module.exports = __webpack_public_path__ + "img/bne1.24295609.jpg";